// --- GSAP等の設定 ----
// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
	// var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		if (target.length > 0) {
			var position = target.offset().top - headerHeight;
			$("html, body").animate({ scrollTop: position }, 550, "swing");
			return false;
		}
	});
})


// // ページトップボタンの表示 // Display the page top button
// jQuery(function ($) {

// 	if ($('#pageup').length > 0) {
// 		var topBtn = $('#pageup');
// 		topBtn.css("display", "none");
// 		//スクロールが100に達したらボタン表示 // display button when scroll reaches 100
// 		$(window).scroll(function () {
// 			if ($(this).scrollTop() > 100) {
// 				topBtn.fadeIn();
// 			} else {
// 				topBtn.fadeOut();
// 			}
// 		});
// 		//スクロールしてトップ // scroll to the top
// 		topBtn.click(function () {
// 			$('body,html').animate({
// 				scrollTop: 0
// 			}, 500);
// 			return false;
// 		});
// 	}
// });


// // ドロワーメニュー // Drawer menu
// jQuery(function ($) {
// 	if ($('.l-hamburger').length > 0) {
// 		$('.l-hamburger').click(function () {
// 			var parentHeader = $(this).closest('header');
// 			var nav = parentHeader.find('nav');
// 			var bg = $('.drawer_bg', parentHeader);

// 			$(this).toggleClass('toggle_active');
// 			bg.fadeToggle();
// 			$('body').toggleClass('drawer_open');

// 			if ($(this).hasClass('toggle_active')) {
// 				nav.addClass('is_open');
// 				nav.removeClass('is_close');
// 			} else {
// 				nav.removeClass('is_open');
// 				nav.addClass('is_close');
// 			}
// 		});

// 		$('.drawer_bg').click(function () {
// 			var parentHeader = $(this).closest('header');
// 			var nav = parentHeader.find('nav');
// 			var bg = $('.drawer_bg', parentHeader);

// 			bg.fadeOut();
// 			$('.l-hamburger').removeClass('toggle_active');
// 			$('body').removeClass('drawer_open');
// 			nav.removeClass('is_open');
// 			nav.addClass('is_close');
// 		});

// 		// エリア内リンク用 // For links within an area
// 		$('nav a').on('click', function () {
// 			// if (window.innerWidth <= 768) {
// 			if ($('.l-hamburger:visible').length > 0) {
// 				$('.l-hamburger').click();
// 			}
// 		});
// 	}
// });



document.addEventListener('DOMContentLoaded', function (event) {

	// --- scrollEffect ---
	if (document.querySelector('.js-slideup')) {
		document.querySelectorAll('.js-slideup').forEach(elm => {

			ScrollTrigger.create({
				toggleActions: 'play pause resume reset',
				trigger: elm,
				start: `top bottom`,
				onEnter: function () {
					elm.classList.remove('init');
				},
				onLeaveBack: function () {
					elm.classList.add('init');
				},
			});

		});
	}


});